import { Theme } from '@mui/material/styles';

export const getStyles = (theme: Theme) => ({
  root: {
    display: "flex",
    flexGrow: 1,
    "& > *": {
      margin: theme.spacing(2),
    },
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    // fontWeight: theme.typography.fontWeightRegular,
  },
  batchNumber: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: "5%",
    flexShrink: 0,
    alignItems: "left",
  },
  batchFileName: {
    fontSize: theme.typography.pxToRem(15),
    width: 240,
    maxWidth: 240,
    flexShrink: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    marginRight: theme.spacing(1),
  },
  batchDate: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: "24%",
    flexShrink: 0,
    alignItems: "center",
  },
  batchTriggeredBy: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: "18%",
    flexShrink: 0,
    alignItems: "center",
  },
  batchStatus: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: "20%",
    flexShrink: 0,
    textAlign: "right",
    alignSelf: "center"
  },
  triggeredByLabel: {
    fontSize: theme.typography.pxToRem(12),
    color: theme.palette.text.secondary,
    whiteSpace: "nowrap",
    textAlign: "center",
  },
  triggeredByBadge: {
    fontSize: theme.typography.pxToRem(12),
    fontWeight: 700,
    lineHeight: 1,
    padding: "5px 10px",
    borderRadius: "999px",
    whiteSpace: "nowrap",
    border: "1px solid transparent",
    width: "fit-content",
    margin: "4px auto 0",
  },
  triggeredByTeacher: {
    backgroundColor: "#E3F2FD",
    color: "#1565C0",
    borderColor: "#90CAF9",
  },
  triggeredByAdmin: {
    backgroundColor: "#E8F5E9",
    color: "#2E7D32",
    borderColor: "#A5D6A7",
  },
  triggeredByUnknown: {
    backgroundColor: "#F5F5F5",
    color: theme.palette.text.secondary,
    borderColor: "#E0E0E0",
  },
  batchControls: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: "50%",
    flexShrink: 0,
    alignItems: "left",
  },
  batchSummary: {
    fontSize: theme.typography.pxToRem(18),
    flexBasis: "100%",
    flexShrink: 0,
    textAlign: "center",
  },
  tableRoot: {
    width: "100%",
  },
  tableCell: {
    paddingBlock: "6px",
    whiteSpace: "nowrap"
  },
  tableHeader: {
    paddingBlock: "6px",
  },
  listControls: {
    fontSize: theme.typography.pxToRem(13),
    flexBasis: "25%",
    flexShrink: 0,
    textAlign: "center",
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
    width: "75%",
  },
  loaderContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  placeHolder: {
    height: "20px",
  },
  mt2: {
    marginTop: theme.spacing(2),
  },
  ml: {
    marginLeft: theme.spacing(3),
  },
  failed: {
    color: "red",
  },
  finished: {
    color: "green",
  },
  cancelled: {
    color: "gray",
  },
  running: {
    color: "lightblue",
  },
  suspended: {
    color: "orange",
  },
  approved: {
    color: "slateblue",
  },
  created: {
    color: "black",
  },
  warning: {
    color: "orange",
  },
  button: {
    margin: theme.spacing(1),
  },
  changesModal: {
    position: 'absolute',
    width: "80%",
    height: 650,
    overflowY: "auto",
    overflowX: "auto",
    backgroundColor: theme.palette.background.paper,
    border: '1px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
  successIcon: {
    padding: "6px",
    color: "green"
  },
  warnIcon: {
    padding: "6px",
    color: "orange"
  },
  runIcon: {
    padding: "6px",
  }
});
